<template>
    <div id="geocoder"></div>
</template>
<script>
export default {
    name: "GeoCoder",
};
</script>
<style>
@import "@mapbox/mapbox-gl-geocoder/dist/mapbox-gl-geocoder.css";
#geocoder {
    width: 539px;
    position: fixed;
    z-index: 10000;
    top: 80px;
    left: 10px;
}

.mapboxgl-ctrl-geocoder,
.mapboxgl-ctrl-geocoder--suggestion,
.mapboxgl-ctrl-geocoder--powered-by a {
    font-family: "Inter", Arial, sans-serif !important;
}

/* @media (max-width: 1200px) {
    #geocoder {
        top: 80px;
    }
} */
@media (max-width: 750px) {
    #geocoder {
        width: 94vw;
        left: 3vw;
        top: calc(54px + 3vw);
    }
}
</style>
